import AbstractMediator from "../../../core/ui/AbstractMediator";
import LaptopNavigateEvent from "../model/LaptopNavigateEvent";

export default class AbstractLaptopMediator extends AbstractMediator {
    constructor(target, dispatcher, layoutManager, clickEaterFactory) {
        super(target, dispatcher, layoutManager, clickEaterFactory);
    }

    getGotoScreenRequest(screenType, screen, autoCenter, priority, needsOverlay, openUnderCurrent, animationType, animationOptions) {
        return new LaptopNavigateEvent(LaptopNavigateEvent.GOTO_SCREEN_REQUEST, screenType, screen, autoCenter, priority, needsOverlay, openUnderCurrent, animationType, animationOptions);
    }

    getOpenScreenRequest(screenType, screen, autoCenter, priority, needsOverlay, openUnderCurrent, animationType, animationOptions) {
        return new LaptopNavigateEvent(LaptopNavigateEvent.OPEN_SCREEN_REQUEST, screenType, screen, autoCenter, priority, needsOverlay, openUnderCurrent, animationType, animationOptions);
    }

    getCloseScreenRequest(screenType, screen, autoCenter, priority, needsOverlay, openUnderCurrent, animationType, animationOptions) {
        return new LaptopNavigateEvent(LaptopNavigateEvent.CLOSE_SCREEN_REQUEST, screenType, screen, autoCenter, priority, needsOverlay, openUnderCurrent, animationType, animationOptions);
    }
}